import {Injectable} from '@angular/core';
import {generateUniqueId} from '../../../../utils/math-utils';
import {Article} from '../article';
import {EnumCorridorColor} from '../../../enum/enum-corridor-color';
import {EnumPricingItemType} from '../pricing-item-type';
import {Option} from '../../../option/option.model';
import {OptionPricingItem} from '../option-pricing-item';

@Injectable({
    providedIn: 'root'
})
export class OptionPricingItemMapper {

    // Transforme une option du référentiel en pricingItem de type OPTION.
    // Un seul productPricing : le price-engine y recalcule les 5 points du corridor à partir
    // de pcc (blackPrice) et catalogPrice (greenPrice), sans coefficient (prix finaux).
    // appliedPrice reste null : quote-engine assigne par défaut le prix vert foncé (p90).
    // Les quantityTiers ne sont pas exploités dans cette itération.
    getPricingItemFromOption(option: Option, quantity: number = 1): OptionPricingItem {
        return new OptionPricingItem().copyWith({
            id: generateUniqueId(),
            isValid: true,
            isSelected: false,
            isCmc: false,
            pricingItemType: EnumPricingItemType.OPTION,
            granularity: option.granularity,
            precalculatedQuantity: option.precalculatedQuantity,
            userInputs: {quantity: quantity},
            option: new Article().copyWith({
                codeElis: option.code,
                label: option.code,
                appliedPrice: null,
                appliedPriceColor: EnumCorridorColor.GRAY,
                pcc: String(option.blackPrice),
                catalogPrice: String(option.greenPrice),
                productPricings: [{
                    id: null,
                    p10: null,
                    p10p50: null,
                    p50: null,
                    p50p90: null,
                    p90: null,
                    r1090: '0',
                    r3090: '0',
                    r5090: '0',
                    r7090: '0',
                    type: null,
                    productPricingDetails: {}
                }]
            })
        });
    }
}
